// hooks/useAtualizarDados.ts
import { useState } from "react";
import { Anuncio } from "../../../interfaces/Anuncio";
import { cadastrarAnuncioPropriedade } from "../../../services/cadastrarAnuncioPropriedadeService";
// --------------------- Import Services ---------------------

export const useAdicionarAnuncio = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const cadastrar = async (data: Partial<Anuncio>) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const cadastrarDados = await cadastrarAnuncioPropriedade(data);
      if (cadastrarDados) {
        setSuccess(true);
      } else {
        setError(true);
      }
      return cadastrarDados;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    cadastrar,
    isLoading,
    isSuccess,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
